export default {
    FUNDINGS ({ fundings }) {
      return fundings
    },
    FUNDINGS_DETAIL ({ fundingsDetail }) {
      return fundingsDetail
    },
    COMPANIES ({ companies }) {
      return companies
    },
    COMPANYNAMES ({ companyNames }) {
      return companyNames
    },
    EXPORT_TOTAL_COUNT ({ exportTotalCount }) {
      return exportTotalCount
    },
    FUNDINGS_BY_RG ({ fundingsRG }) {
      return fundingsRG
    }
}
